import React, { Component } from 'react'
import { string, number, bool, func, arrayOf, shape, oneOfType } from 'prop-types'
import { isNotEmpty, validateRules } from '../../../utilities/validators'

class TextAreaComponent extends Component {
  constructor () {
    super()
    this.state = {
      errors: [],
      isValid: true
    }

    this.handleValidation = this.handleValidation.bind(this)
  }

  componentWillReceiveProps (nextprops) {
    this.setState({value: nextprops.value})
  }

  validate () {
    const value = this.refs[this.props.name].value
    let errors = []
    if (this.props.rules) {
      errors = validateRules(this.props.rules, this.refs[this.props.name].value).errors
    }
    if (this.props.required && !isNotEmpty(value)) {
      errors.push({message: 'Ce champ est obligatoire'})
    }
    return { errors, isValid: !errors.length }
  }

  handleChange () {
    const value = this.refs[this.props.name].value
    const { isValid, errors } = this.validate()

    if (this.props.onChange) {
      this.props.onChange(value, isValid)
    }
    this.setState({ value })
    clearTimeout(this._rulesValidationTimeout)
    this._rulesValidationTimeout = setTimeout(() => {
      this.setState({ isValid, errors })
    }, 500)
  }

  /*
   * Validation handler called on value change
   */
  handleValidation () {
    const result = this.validate()
    this.setState({...result})
    return { label: this.props.label, ...result}
  }

  render () {
    const { name, label, cols, rows, placeholder, className, value } = this.props
    const { isValid, errors } = this.state

    return (
      <div>
        <label style={(this.props.bold) ? {fontWeight: 500} : {}} className={'form__label ' + (!isValid ? 'form__label--error' : '')} htmlFor={name} >{label}</label>
        <textarea
          id={name}
          ref={name}
          defaultValue={value}
          onBlur={() => this.setState({ ...this.handleValidation() })}
          onChange={() => this.handleChange()}
          className={(className ? className + ' form__input' : 'form__input') + (errors.length ? ' form__input--error' : '')}
          name={name} cols={cols}
          rows={rows}
          placeholder={placeholder} />
        {errors.length ? <p className='form__errormessage'>{errors[0].message}</p> : ''}
      </div>
    )
  }
}

TextAreaComponent.propTypes = {
  name: string.isRequired,
  label: string,
  cols: number,
  rows: number,
  className: string,
  placeholder: string,
  required: bool,
  bold: bool,
  onChange: func,
  rules: arrayOf(shape({
    type: string,
    message: string,
    expected: oneOfType([
      string,
      number,
      bool
    ])
  })),
  value: string
}

export const TextArea = TextAreaComponent



// WEBPACK FOOTER //
// ./src/components/ui/inputs/TextArea.js